<form [formGroup]="loginForm" name="loginForm" novalidate>
  <mat-form-field [floatLabel]="floatLabelControl">
    <mat-label>{{ 'authentication.login' | translate }}</mat-label>
    <input [attr.disabled]="renewPassword && settings.activeChangePasswordStrategy"
      data-e2e="login-form-login"
      formControlName="login"
      matInput
      required
      />

      @if (loginFormErrors.login.required) {
        <mat-error>
          <span>{{ "authentication.login.required" | translate }}</span>
        </mat-error>
      }

      @if (loginFormErrors.login.invalid) {
        <mat-error>
          <span>{{ "authentication.login.invalid" | translate }}</span>
        </mat-error>
      }

      @if (loginFormErrors.login.email) {
        <mat-error>
          <span>{{ "authentication.login_email" | translate }}</span>
        </mat-error>
      }
    </mat-form-field>

    @if (!renewPassword) {
      <mat-form-field [floatLabel]="floatLabelControl"
        >
        <mat-label>{{ 'authentication.password' | translate }}</mat-label>
        <input
          [attr.disabled]="(renewPassword && settings.activeChangePasswordStrategy) || loginFormErrors.emailValidation.invalid"
          [type]="hide ? 'password' : 'text'"
          data-e2e="login-form-password"
          formControlName="password"
          matInput
          required
          />
          <mat-icon
            (click)="hide = !hide"
            (keydown.enter)="hide = !hide"
            tabindex="0"
            [attr.aria-label]="(hide ? 'accessibility.visibility_on' : 'accessibility.visibility_off') | translate"
            class="visibility-icon"
            matSuffix
            svgIcon="{{ hide ? 'visibility' : 'visibility_off' }}"
            [attr.data-e2e]="hide?'login-form-password-hide':'login-form-password-show'">
          </mat-icon>
          @if (loginFormErrors.password.required) {
            <mat-error>
              <span>{{ "authentication.password.required" | translate }}</span>
            </mat-error>
          }
          @if (loginFormErrors.password.invalid) {
            <mat-error>
              <span>{{ "authentication.password.invalid" | translate }}</span>
            </mat-error>
          }
        </mat-form-field>
      }

      @if (renewPassword && settings.activeChangePasswordStrategy) {
        <mat-form-field
          [floatLabel]="floatLabelControl">
          <mat-label>{{ 'authentication.new.password' | translate }}</mat-label>
          <input
            [type]="hideNewPassword ? 'password' : 'text'"
            autocomplete="off"
            formControlName="newPassword"
            matInput
            name="changePassword"
            data-e2e="login-form-new-password"
            required
            />
            <mat-icon
              (click)="hideNewPassword = !hideNewPassword"
              (keydown.enter)="hideNewPassword = !hideNewPassword"
              tabindex="0"
              [attr.aria-label]="(hideNewPassword ? 'accessibility.visibility_on' : 'accessibility.visibility_off') | translate"
              matSuffix
              svgIcon="{{ hideNewPassword ? 'visibility' : 'visibility_off' }}"
              [attr.data-e2e]="hideNewPassword?'login-form-new-password-hide':'login-form-new-password-show'">
            </mat-icon>
            @if (loginFormErrors.newPassword.required) {
              <mat-error>
                <span>{{ "authentication.password.required" | translate }}</span>
              </mat-error>
            }
            @if (loginFormErrors.newPassword.samePasswordAsOrigine) {
              <mat-error>
                <span>{{ "authentication.password.must.be.change" | translate }}</span>
              </mat-error>
            }
          </mat-form-field>
        }

        @if (renewPassword && settings.activeChangePasswordStrategy) {
          <mat-form-field
            [floatLabel]="floatLabelControl">
            <mat-label>{{ 'authentication.new.password' | translate }}</mat-label>
            <input
              [type]="hideConfirmPassword ? 'password' : 'text'"
              autocomplete="off"
              formControlName="confirmPassword"
              matInput
              name="confirmPassword"
              data-e2e="login-form-confirm-password"
              required
              />
              <mat-icon
                (click)="hideConfirmPassword = !hideConfirmPassword"
                (keydown.enter)="hideConfirmPassword = !hideConfirmPassword"
                tabindex="0"
                [attr.aria-label]="(hideConfirmPassword ? 'accessibility.visibility_on' : 'accessibility.visibility_off') | translate"
                matSuffix
            svgIcon="{{
                  hideConfirmPassword ? 'visibility' : 'visibility_off'
                }}"
                [attr.data-e2e]="hideConfirmPassword?'login-form-confirm-password-hide':'login-form-confirm-password-show'"
                >
              </mat-icon>
              @if (loginFormErrors.confirmPassword.notMatch) {
                <mat-error>
                  <span>{{ "account-management.password-confirm.not-identical" | translate }}</span>
                </mat-error>
              }
            </mat-form-field>
          }

          @if (!settings.enableSSO && !renewPassword) {
            <div
              class="remember-forgot-password"
              fxLayout="row"
              fxLayout.xs="column"
              fxLayoutAlign="space-between center"
              >
              <a [routerLink]="'/forgot-password'" class="forgot-password"
                data-e2e="login-form-forgotten-password">
                {{ "authentication.forgotten-password" | translate }}
              </a>
            </div>
          }

          <app-register-link></app-register-link>

          @if (!loginFormErrors.emailValidation.invalid) {
            <button
              (click)="onLoginClick()"
              [disabled]="loginForm.invalid"
              class="submit-button"
              data-e2e="login-form-submit"
              >
              {{ "authentication.btn-login" | translate }}
            </button>
          }
          <!-- if auto redirection doesnt work -->
          @if (showMessageForReloadPage) {
            <mat-error>
              <span class="show-message-reload-page">
              {{ "generic.message_reload_page" | translate }}</span>
            </mat-error>
          }
          <!--if mail was not validated error msg and button to send again email link -->
          @if (loginFormErrors.emailValidation.invalid) {
            <mat-error>
              <span>{{ "generic.email.validation.invalid" | translate }}</span>
            </mat-error>
          }
          <!--no licence-->
          @if (loginFormErrors.licenceValidation.invalid) {
            <mat-error>
              <span>{{ "generic.validation.licence.invalid" | translate }}</span>
            </mat-error>
          }
          @if (newLinkSendError) {
            <mat-error>
              <span>{{ "generic.email.not.send" | translate }}</span>
            </mat-error>
          }

          @if (newLinkSendSuccess) {
            <p>
              {{ "generic.email.send" | translate }}
            </p>
          }

          @if (!!licenceLink) {
            <p
              class="login__licence-link">{{ 'account-management.ask_licence_part1' | translate }}
              <a
                [href]="licenceLink"
                ariaLabelTranslate="{{ 'account-management.ask_licence_part2' | translate }}"
                class="link"
                target="_blank"
                data-e2e="login-form-ask-licence">
              {{ "account-management.ask_licence_part2" | translate }}</a>
            </p>
          }

          @if (loginFormErrors.emailValidation.invalid) {
            <button
              (click)="onSendLinkToValidateEmailClick()"
              color="accent"
              mat-raised-button
              data-e2e="login-form-send-email-validation">
              {{ "generic.email.validation.invalid.send.new.link" | translate }}
            </button>
          }
        </form>